const Overlay = () => (
  <div className="bg-white position-absolute left-0 top-0 w-100 h-100 z-100 opacity-50" />
);

export default Overlay;
